import React, { Component } from 'react';

import Helmet from './Helmet';

const Title = 'ClickUp Case Study | Canny';
const Description =
  'Read about how ClickUp uses Canny to keep track of feedback from a rapidly growing user base.';
const Image = 'https://canny.io/images/helmet-clickup-case-study.jpg';

export default class ClickupLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: 'https://canny.io/case-studies/clickup' },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}
      />
    );
  }
}
